import { MessagesAPI } from '../api/MessagesAPI';

export const MessagesRepository = {
  notifyDesktop: (contextData, requestData) => MessagesAPI.notifyDesktop(contextData, requestData)
};